import { userContract } from './user.contract';
import { userPreferencesContract } from './userPreferences.contract';
import { tradesContract } from './trades.contract';
import { defaultCertificatesContract } from './defaultCertificates.contract';

// Individual re-exports (for route files importing specific contracts)
export { userContract } from './user.contract';
export { userPreferencesContract } from './userPreferences.contract';
export { tradesContract } from './trades.contract';
export { defaultCertificatesContract } from './defaultCertificates.contract';

// Aggregated export for service client creation
export const entitiesContracts = {
	userContract,
	userPreferencesContract,
	tradesContract,
	defaultCertificatesContract,
};
